<c-modal
  [titleText]="'password-change.extraValidation.title' | translate"
  [cancelText]="'password-change.extraValidation.cancel' | translate"
  [confirmText]="'password-change.extraValidation.confirm' | translate"
>
  <div class="c-flex c-flex-column c-gap-m">
    <span>{{'password-change.extraValidation.summary' | translate }}</span>
    <span>{{'password-change.extraValidation.description' | translate }}</span>
  </div>
</c-modal>
